module.exports = __webpack_public_path__ + "media/images/admin2/AdminAgenciesDetails__header__img-1577ed64ccf0dfffe500c0450e119f34.svg";